import React from 'react';
import PropTypes from 'prop-types';

/**
 * PlainButton — a bare `<button type="button">` whose look comes entirely from the caller's
 * className. Shared across the copilot for every plain/icon button (toggle segments, "Show
 * all/fewer", action button, header icon buttons, composer buttons, etc.). The caller passes
 * the already-computed aphrodite class so the rendered markup stays byte-identical to the
 * original inline buttons. Optional aria-label/title/disabled are omitted from the DOM when
 * left undefined, matching buttons that didn't set them.
 */
export default function PlainButton({ className, onClick, children, ariaLabel, title, disabled }) {
  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      aria-label={ariaLabel}
      title={title}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
PlainButton.propTypes = {
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  ariaLabel: PropTypes.string,
  title: PropTypes.string,
  disabled: PropTypes.bool,
};
PlainButton.defaultProps = { ariaLabel: undefined, title: undefined, disabled: undefined };
